import { QuestionnaireFormType } from "@/modules/patients/detail/progress-note/components/questionnaire"
import { useProgressNoteFormContext } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteFormStore"
import { useStoreFormState } from "@/modules/patients/detail/progress-note/hooks/useStoreFormState"
import { AsyncRequestStatus } from "@/types/__generated__/union-types"

export const useProgressNoteQuestionSummaryForm = (id: string, questionnaireStatus: AsyncRequestStatus | null) => {
  const progressNoteForms = useProgressNoteFormContext((state) => state.progressNoteForms)

  const storeForm = progressNoteForms.get(id)?.questionnaireForm

  const storeFormValue = storeForm?.getValues()

  let defaultValues: Partial<QuestionnaireFormType>

  if (storeFormValue) {
    defaultValues = { ...storeFormValue, formIsDirty: false }
  } else {
    defaultValues = {
      questionnaireStatus: !!questionnaireStatus,
      formIsDirty: false,
    }
  }

  const storeFormState = useStoreFormState(storeForm)

  return { defaultValues, storeFormState }
}
